import { Dayjs } from 'dayjs'
import { Project } from '../../store/types'
import React, { RefObject, useEffect, useState } from 'react'
import { Box, Table, TableBody, TableCell, TableHead, TableRow, useMediaQuery, useTheme } from '@mui/material'
import VacancyHeaderChip from './VacancyHeaderChip'
import Demand from '../../store/types/models/Demand'
import LoadingWrapper from '../Loading/LoadingWrapper'

type VacancyTableProps = {
  month: Dayjs
  stateProjects: Project[]
  demandResponse: Demand[]
  isLoading: boolean
  employeeAdded?: boolean
  isEditionDisabled(): boolean
  vacancyRef: React.RefObject<HTMLButtonElement>
  addEmployeeRef: RefObject<HTMLButtonElement>
  firstProjectRef: RefObject<HTMLDivElement>
}

export const VacancyTable = ({
  month,
  stateProjects,
  demandResponse,
  isLoading,
  employeeAdded = false,
  isEditionDisabled,
  vacancyRef,
  addEmployeeRef,
  firstProjectRef
}: VacancyTableProps) => {
  const [totalPeople, setTotalPeople] = useState<number>(0)
  const theme = useTheme()
  const isDownSm = useMediaQuery(theme.breakpoints.down('sm'))

  useEffect(() => {
    setTotalPeople(demandResponse.reduce((acc, demand) => acc + demand.numberOfPeople, 0))
  }, [demandResponse])

  stateProjects.sort((a, b) => a.name.localeCompare(b.name))

  return (
    <Box sx={{ maxWidth: isDownSm ? '100px' : '120px' }}>
      <LoadingWrapper isLoading={isLoading}>
        {stateProjects.length !== 0 && (
          <Table size="small" sx={{ maxWidth: isDownSm ? '80px' : '100px', zIndex: 1, position: 'sticky' }}>
            <TableHead>
              <TableRow>
                <VacancyHeaderChip
                  month={month}
                  stateProjects={stateProjects}
                  demandResponse={demandResponse}
                  isEditionDisabled={isEditionDisabled}
                  vacancyRef={vacancyRef}
                  addEmployeeRef={addEmployeeRef}
                  firstProjectRef={firstProjectRef}
                />
              </TableRow>
            </TableHead>
            <TableBody>
              {stateProjects.map(project => {
                const demand = demandResponse.find(d => d.project.id === project.id)
                return (
                  <TableRow key={project.id} sx={{ height: '50px', maxHeight: '50px' }}>
                    <TableCell
                      sx={{
                        borderTop: '1px solid',
                        borderBottom: '1px solid',
                        borderColor: 'background.elevation8',
                      }}
                      align="center"
                    >
                      {demand ? demand.numberOfPeople * 100 + '%' : '-'}
                    </TableCell>
                  </TableRow>
                )
              })}
              {employeeAdded && (
                <TableRow sx={{ height: '50px', maxHeight: '50px' }}>
                  <TableCell></TableCell>
                </TableRow>
              )}
              <TableRow sx={{ height: '50px', maxHeight: '50px' }}>
                <TableCell
                  sx={{
                    borderTop: '1px solid',
                    borderBottom: '1px solid',
                    borderColor: 'background.elevation8',
                    fontWeight: totalPeople === 0 ? 'normal' : 'bold',
                  }}
                  align="center"
                >
                  {totalPeople * 100 + '%'}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        )}
      </LoadingWrapper>
    </Box>
  )
}
